import DataGrid2 from '../..';
import { IControlProperties } from '../../../../../../entities';
import { FileSelect } from '../../components';
import { IDataGridColumn } from '../../entities';
import { calculateCellValueForRelationGrid } from './commonHelpers';
import { CustomizedDxColumn } from './generateColumns';

export const setTextBox = (
	dataGrid: DataGrid2,
	bcColumn: IDataGridColumn<IControlProperties>,
	dxColumn: CustomizedDxColumn
) => {
	if (dataGrid.dataSourceType === 'relation') {
		dxColumn.calculateCellValue = calculateCellValueForRelationGrid;
	} else if (bcColumn.formatType.type === 'image') {
		dxColumn.cellComponent = FileSelect;
	}
};
